import BaseComponent from 'scripts/BaseComponent.js';

export default class ActiveFilter extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {};

    this.dom = {
      $component: component,
    };

    this.state = {
      removeFilterEvent: 'removefilter',
      resetPriceFilterEvent: 'resetpricefilter',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    if (dom.$component.dataset.resetPriceFilter) {
      this.setClickWithElement(dom.$component, this.resetPriceFilter);
    } else {
      this.setClickWithElement(dom.$component, this.removeFilter);
    }
  }

  removeFilter(button) {
    const { state: { removeFilterEvent } } = this;
    const { name, value } = button.dataset;

    button.remove();
    this.dispatch(removeFilterEvent, { name, value });
  }

  resetPriceFilter(button) {
    const { state: { resetPriceFilterEvent } } = this;

    button.remove();
    this.dispatch(resetPriceFilterEvent);
  }
}
